import { ref, Ref } from "vue";
import { removeBodyScroll, addBodyScroll } from "@/utils/Utils";

const mountedModals: Array<{
  name: string;
  modalClass: Ref<string | null>;
  type: string;
}> = [];

const openClass = "modal show";
const closeClass = "modal hide";

export default () => {
  const onModalMounted = (modalName: string, type = ""): Ref<string | null> => {
    const currentModal = mountedModals.find(
      (m: any) => m.name == modalName && m.type == type
    );
    if (!currentModal) {
      const newModal = {
        name: modalName,
        modalClass: ref(closeClass),
        type: type,
      };
      mountedModals.push(newModal);
      return newModal.modalClass;
    }
    return currentModal ? currentModal.modalClass : ref("");
  };

  const onModalDestroy = (modalName: string) => {
    const indexToRemove = mountedModals.findIndex(
      (m: any) => m.name == modalName
    );
    if (indexToRemove > 0) {
      const result = [
        ...mountedModals.slice(0, indexToRemove),
        ...mountedModals.slice(indexToRemove + 1),
      ];
    }
  };

  const toggleModal = (modalName: string, title = "") => {
    const currentModal = mountedModals.find(
      (m: any) => m.name == modalName && m.type == title
    );
    if (currentModal && currentModal.modalClass.value) {
      if (currentModal.modalClass.value == openClass) {
        currentModal.modalClass.value = closeClass;
        addBodyScroll();
      } else {
        currentModal.modalClass.value = openClass;
        removeBodyScroll();
      }
    }
  };

  const getModalClass = (modalName: string) => {
    const currentModal = mountedModals.find((m: any) => m.name == modalName);
    if (currentModal) return currentModal.modalClass;
    return ref("");
  };

  return { onModalMounted, toggleModal, getModalClass, onModalDestroy };
};
